// extracted by mini-css-extract-plugin
export default {"shippingStatusContainer":"OC-z","shipmentMessage":"PC-z","shipmentNumber":"QC-z","trackingProgressContainer":"RC-z"};